const PointStartIcon = ({ size = 18, color = "#1d9bf0" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="4" fill="#000" />
  </svg>
)

export default PointStartIcon
